import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useMutation } from "react-query";
import styles from "../styles/Login.module.css";
// import pwcLogo from "../assets/newLogo.svg";
import pwcImage from "../assets/Pattern.svg";
import pwcLogo from "assets/images/pwc.svg";
import Input from "../components/Input";
import { HtmlTooltip } from "../contansts";
import {
  Button,
  Divider,
  IconButton,
  InputAdornment,
  CircularProgress,
  Grid2,
  Link,
  Typography,
  FormHelperText,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Lock } from "@mui/icons-material";
import axios from "../utilis/axios";
import { openSnackbar, closeSnackbar } from "../store/slices/snackbar";
import { useAuth } from "context/AuthContext";
import ImgLogo from "assets/LogoPwC.png"
import { msalInstance,ensureMsalInitialized } from "../auth/msalInstance";
import { loginRequest } from "../auth/msalConfig";


const fetchPostData = async (object) => {
  try {
    const params = new URLSearchParams();
    Object.keys(object).forEach((key) => {
      params.append(key, object[key]);
    });
    const response = await axios.post("account/login", params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    // throw new Error(error.value || "Something went wrong");
    throw error;
  }
};

const Login = () => {
  const theme = useTheme();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState(1);
  const [error, setError] = useState({ userName: "", password: "", otp: "" });
  const [rememberMe, setRememberMe] = useState(false);
  const [ssoLoading, setSsoLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { getuserInfo } = useAuth();
  const isMobile = useMediaQuery('(max-width:768px)');
  let notificationTimeout;

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.userId) {
      // navigate("/user-management/user-list");
    }
  }, [navigate]);

  const openNotification = async (msg, type = "error") => {
    await dispatch(
      openSnackbar({
        open: true,
        message: msg,
        variant: "alert",
        alert: {
          color: type,
        },
        close: false,
      })
    );

    notificationTimeout = setTimeout(() => dispatch(closeSnackbar()), 6000);
  };

  const mutation = useMutation(fetchPostData, {
    onSuccess: (response) => {
      if (response.otp) {
        setStep(2);
        openNotification(
          `OTP sent to your registered contact: ${response.otp}`,
          "info"
        );
      } else if (response.access_token) {
        handleSuccess(response);
      }
    },
    onError: (error) => {
      // if(error?.)
      console.log(error?.status);
      if (error?.status == "Failed") {
        openNotification(error?.message || "Something went wrong");
      }
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError({ userName: "", password: "", otp: "" });

    if (step === 1) {
      let errors = {};
      if (!userName.trim()) {
        errors.userName = "Please enter username";
      }
      if (!password.trim()) {
        errors.password = "Please enter password";
      }
      if (Object.keys(errors).length > 0) {
        setError((prev) => ({ ...prev, ...errors }));
        return;
      }

      try {
        const response = await mutation.mutateAsync({
          username: userName.trim(),
          Password: password.trim(),
          grant_type: "Password",
        });

        if (response?.message) {
          openNotification(response.message, "success");
          if (response?.firstLogin) {
            navigate("/forgotPassword", {
            // navigate("/terms-conditions", {
              state: { firstLogin: true, username: userName },
            });
          } else {
            setStep(2);
          }
        } else {
          openNotification("Login failed, please try again.");
        }
      } catch (error) {
        if(error?.status==409)
          openNotification(" You are already signed in on another device. Please log out from other device or contact your Administrator");
        else
          openNotification(error?.message || "Something went wrong");
      }
    } else {
      if (!otp.trim()) {
        setError((prev) => ({ ...prev, otp: "OTP cannot be empty" }));
        return;
      }

      try {
        const response = await mutation.mutateAsync({
          username: userName.trim(),
          Password: password.trim(),
          grant_type: "Password",
          otp: otp.trim(),
        });

        if (response?.access_token) {
          openNotification("OTP verification successful.", "success");
          // navigate("/user-management/user-list");
          // navigate("/program-dashboard/program-dashboard");

        } else {
        }
      } catch (error) {
        openNotification(error?.message || "Something went wrong");
      }
    }
  };

  const handleReset = async () => {
    try {
      const response = await mutation.mutateAsync({
        username: userName,
        Password: password,
        grant_type: "Password",
      });

      if (response?.message) {
        openNotification(response.message, "success");
        if (response?.firstLogin) {
          //navigate("/forgotPassword", {
          navigate("/terms-conditions", {
            state: { firstLogin: true, username: userName },
          });
        } else {
          setStep(2);
        }
      } else {
        openNotification("Login failed, please try again.");
      }
    } catch (error) {
      openNotification(error?.message);
    }
  };

  const handleSuccess = (data) => {
    // if (rememberMe) {
    localStorage.setItem("token", data.access_token);
    localStorage.setItem("user", JSON.stringify({ userName: userName }));
    getuserInfo(data.access_token)
    // } else {
    //   sessionStorage.setItem("token", data.access_token);
    //   sessionStorage.setItem("user", JSON.stringify({ userName: userName }));
    //   localStorage.setItem("token", data.access_token);
    //   localStorage.setItem("user", JSON.stringify({ userName: userName }));
    // }
    clearTimeout(notificationTimeout);
    dispatch(closeSnackbar());
    // navigate("/user-management/user-list");
  };

  const handleForgotPassword = () => {
    navigate("/forgotPassword");
  };

  const startSso = async () => {
    setSsoLoading(true);
    try {
      // Redirect to Azure / Entra login page. This will navigate away from the SPA.
      await ensureMsalInitialized();
      await msalInstance.loginRedirect(loginRequest);
      // Note: code below will usually not run because the browser is redirected.
    } catch (err) {
      console.error("SSO start failed", err);
      // reuse your notification helper
      openNotification("Failed to start SSO. See console for details.", "error");
      setSsoLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.rightPane}>
        <div className={styles.logoContainer}>
          <img src={ImgLogo} alt="PwC Logo" style={{
            objectFit: 'inherit',
            height:'auto'
          }} />
        </div>
        <div className={styles.formContainer}>
          <h2 className={styles.title}>Welcome to</h2>
          <h1 className={styles.mainTitle}>Integrated Project Control and Analytics Hub</h1>
          <form className={styles.form} onSubmit={handleSubmit}>
            {step === 1 ? (
              <>
                <div className={styles.inputGroup}>
                  <Input
                    label="User name"
                    fullWidth
                    id="email"
                    name="email"
                    value={userName}
                    onChange={(e) => {
                      setUserName(e.target.value);
                      setError((prev) => ({ ...prev, userName: "" }));
                    }}
                  />
                  {error.userName && (
                    <FormHelperText sx={{ color: "#C52A1A", fontSize: "12px" }}>
                      {error.userName}
                    </FormHelperText>
                  )}
                </div>
                <div className={styles.inputGroup}>
                  <Input
                    fullWidth
                    name="password"
                    label="Password"
                    type={showPassword ? "text" : "password"}
                    id="password"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setError((prev) => ({ ...prev, password: "" }));
                    }}
                    icon={Lock}
                    InputProps={{
                      disableUnderline: true,
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            sx={{ mr: 1 }}
                          >
                            {showPassword ? (
                              <HtmlTooltip
                                title={"Hide password"}
                                arrow
                                placement="bottom"
                                sx={{ fontSize: 12 }}
                              >
                                <Visibility style={{ fontSize: 20 }} />
                              </HtmlTooltip>
                            ) : (
                              <HtmlTooltip
                                title={"Show password"}
                                arrow
                                placement="bottom"
                                sx={{ fontSize: 12 }}
                              >
                                <VisibilityOff style={{ fontSize: 20 }} />
                              </HtmlTooltip>
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {error.password && (
                    <FormHelperText sx={{ color: "#C52A1A", fontSize: "12px" }}>
                      {error.password}
                    </FormHelperText>
                  )}
                </div>
                <div className={styles.optionsContainer}>
                  <div className={styles.rememberMeContainer}>
                    <input
                      type="checkbox"
                      id="rememberMe"
                      className={styles.checkbox}
                      style={{
                        border: `2px solid ${theme?.customSettings?.themeColor}`,
                        backgroundColor: rememberMe
                          ? theme?.customSettings?.themeColor
                          : "transparent",
                      }}
                      checked={rememberMe}
                      onChange={() => setRememberMe(!rememberMe)}
                    />
                    <label className={styles.label}>Remember me</label>
                  </div>
                  <button
                    type="button"
                    className={styles.forgotPassword}
                    style={{
                      color: theme?.customSettings?.themeColor,
                    }}
                    onClick={handleForgotPassword}
                  >
                    Forgot password?
                  </button>
                </div>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  disabled={mutation.isLoading}
                  className={styles.loginButton}
                  style={{
                    backgroundColor: theme?.customSettings?.themeColor,
                    color: "#FFF !important",
                  }}
                >
                  {mutation.isLoading ? (
                    <CircularProgress size={24} />
                  ) : (
                    "Login"
                  )}
                </Button>
              </>
            ) : (
              <>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{
                    color: "#696969",
                    fontWeight: "500",
                    fontSize: "13px",
                    lineHeight: "20px",
                    whiteSpace: { xs: 'wrap', sm: 'nowrap' },
                  }}
                >
                  We've sent an OTP to your e-mail address ({userName}).
                  <Link
                    href="/login"
                    sx={{
                      color: theme?.customSettings?.themeColor,
                      textDecorationColor: theme?.customSettings?.themeColor,
                      textUnderlinePosition: "under",
                    }}
                  >
                    Change
                  </Link>
                </Typography>

                <div className={styles.inputGroup}>
                  <Input
                    label="Enter OTP"
                    fullWidth
                    id="otp"
                    name="otp"
                    type="text"
                    value={otp}
                    onChange={(e) => {
                      setOtp(e.target.value);
                      setError((prev) => ({ ...prev, otp: "" }));
                    }}
                  />
                  {error.otp && (
                    <FormHelperText sx={{ color: "#C52A1A", fontSize: "12px" }}>
                      {error.otp}
                    </FormHelperText>
                  )}
                </div>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleReset}
                  fullWidth
                  disabled={mutation.isLoading}
                  className={styles.resendBtn}
                  style={{
                    backgroundColor: "#fff",
                    color: theme?.customSettings?.themeColor,
                    borderColor: theme?.customSettings?.themeColor,
                  }}
                >
                  {mutation.isLoading ? (
                    <CircularProgress size={24} />
                  ) : (
                    "Resend OTP"
                  )}
                </Button>

                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  disabled={mutation.isLoading}
                  className={styles.loginButton}
                  style={{
                    backgroundColor: theme?.customSettings?.themeColor,
                    color: "#FFF !important",
                  }}
                >
                  {mutation.isLoading ? (
                    <CircularProgress size={24} />
                  ) : (
                    "Verify OTP"
                  )}
                </Button>
              </>
            )}
          </form>
          <Divider />
                    {/* ===== NEW: SSO Button ===== */}
          <div style={{ marginTop: 8, marginBottom: 8 }}>
            <Button
              variant="outlined"
              fullWidth
              onClick={startSso}
              disabled={ssoLoading}
              style={{
                borderColor: theme?.customSettings?.themeColor,
                color: theme?.customSettings?.themeColor,
                textTransform: "none",
                padding: "10px 12px",
              }}
              startIcon={ssoLoading ? <CircularProgress size={18} /> : null}
            >
              {ssoLoading ? "Starting SSO..." : "Login using SSO"}
            </Button>
          </div>
          {/* ============================ */}
        </div>
        <footer className={styles.footer}>
          <Grid2 container>
            <Grid2 size={{ xs: 12, md: 12, textAlign: "center" }}>
              <Typography
                variant="body2"
                textAlign={"center"}
                sx={{ fontSize: "14px", color: "#252525" }}
              >
                <span style={{ opacity: 0.5 }}>&copy; 2025 PwC. All rights reserved. PwC refers to india member firm and may sometimes refer to the PwC network. Each member firm is a separate legal entity. Please see </span><Link target="_blank" href="https://www.pwc.com/structure" sx={{
                  color:'#000'
                }}>www.pwc.com/structure</Link> <span style={{ opacity: 0.5 }}>for further details.</span>
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 2 }} />
            <Grid2 size={{ xs: 12, md: 12 }} textAlign={"center"} mt={1}>
              <Link
                target="_blank"
                href="/privacy-policy"
                className={styles.footer_link}
                style={{
                  color: theme?.customSettings?.themeColor,
                  textDecorationColor: theme?.customSettings?.themeColor,
                }}
              >
                Privacy policy
              </Link>{" "}
              {/* |{" "}
              <Link
                href="#"
                className={styles.footer_link}
                style={{
                  color: theme?.customSettings?.themeColor,
                  textDecorationColor: theme?.customSettings?.themeColor,
                }}
              >
                Cookie notice
              </Link>{" "} */}
              |{" "}
              <Link
                target="_blank"
                href="/terms-conditions"
                className={styles.footer_link}
                style={{
                  color: theme?.customSettings?.themeColor,
                  textDecorationColor: theme?.customSettings?.themeColor,
                }}
              >
                Terms and conditions
              </Link>{" "}
              |{" "}
              <Link
                href="/consent-notice"
                className={styles.footer_link}
                style={{
                  color: theme?.customSettings?.themeColor,
                  textDecorationColor: theme?.customSettings?.themeColor,
                }}
              >
                Consent Notice
              </Link>
            </Grid2>
          </Grid2>
        </footer>
      </div>
      {!isMobile &&
        <div className={styles.leftPane}
          style={{
            backgroundImage: `url(${pwcImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          {/* <div className={styles.imageContainer}>
            <img src={pwcImage} alt="PwC Logo" />
          </div> */}
        </div>
      }


    </div>
  );
};

export default Login;
